import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Directive, HostBinding, Inject, Input, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs';
import { componentDestroyed } from '../../utils/component-destroyed';
import { BackdropDirective } from '../backdrop/backdrop.directive';

@Directive({
    selector: '[appSidebar],app-sidebar',
    host: {
        class: 'app-sidebar'
    },
    exportAs: 'appSidebar',
    standalone: false
})
export class SidebarDirective implements AfterViewInit, OnDestroy {

  @Input() position: 'left' | 'right' = 'left';
  @Input() backdrop: BackdropDirective | undefined;
  @Input() invisibleBackdrop: boolean = false;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  private _opened: boolean = false;

  get opened() {
    return this._opened;
  }

  @Input()
  @HostBinding('class.open')
  set opened(open: boolean) {
    this._opened = open;
    open ? this.showBackdrop() : this.hideBackdrop();
  }

  @HostBinding('class.position-left')
  get positionLeft() {
    return this.position === 'left';
  }

  @HostBinding('class.position-right')
  get positionRight() {
    return this.position === 'right';
  }

  ngAfterViewInit(): void {
    if (this.backdrop) {
      this.backdrop?.closed.pipe(
        takeUntil(componentDestroyed(this))
      ).subscribe(() => this.close());
    }

  }

  showBackdrop() {
    if (this.backdrop) {
      if (this.invisibleBackdrop) {
        this.backdrop.showInvisible();
      } else {
        this.backdrop.show();
      }

      this.enableScrollblock();
    }
  }

  hideBackdrop() {
    if (this.backdrop) {
      this.backdrop.hide();
    }

    this.disableScrollblock();
  }

  enableScrollblock() {
    this.document.body.classList.add('app-scrollblock');
  }

  disableScrollblock() {
    this.document.body.classList.remove('app-scrollblock');
  }

  open() {
    this.opened = true;
  }

  close() {
    this.opened = false;
  }

  ngOnDestroy(): void {}
}
